// account urls
export const account = () => '/account'
export const login = () => '/login'
export const register = () => '/register'
export const apps = () => '/apps'
export const homeBase = () => '/'
